import Vue from "vue"
import VueRouter from "vue-router"
import util from '@/utils/index'
import menus from './menus'

/*处理导航重复点击的错误*/
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

//默认路由
const constantRoutes = [
    {
        path: '/',
        redirect: '/login',
        meta: { auth: false, hidden: true },
    }, {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index.vue'),
        meta: { title: '系统登录', auth: false, hidden: true },
    }
]

//动态路由
let dynamicRoutes

//创建路由
const createRouter = () =>
    new VueRouter({
        scrollBehavior: () => ({ y: 0 }),
        routes: [
            ...constantRoutes,
            ...dynamicRoutes || [],
            {
                path: '/403',
                name: '403',
                component: () => import('@/views/error/403.vue'),
                meta: { auth: false, hidden: true },
            }, {
                path: '/404',
                name: '404',
                component: () => import('@/views/error/404.vue'),
                meta: { auth: false, hidden: true },
            }
        ],
    })

//刷新路由
const resetRouter = () => {
    let nowRouter = createRouter()
    router.options = nowRouter.options
    router.matcher = nowRouter.matcher
}


const router = createRouter()

//路由守卫
router.beforeEach(async (to, from, next) => {
    // 路由跳转之前，清空（终止）上一个页面正在请求的内容
    if (window._axiosPromiseArr) {
        window._axiosPromiseArr.map((ele, index) => {
            ele.cancel("请求终止")
            delete window._axiosPromiseArr[index]
        })
    }
    // 检查动态路由
    if ((to.meta.auth ?? true) && !dynamicRoutes) {
        await menus().then((res) => {
            dynamicRoutes = res
            resetRouter()
            next(to.fullPath)
        })
    }
    else {
        next()
    }
})

router.afterEach((to) => {
    util.common.title(to.meta.title) // 更改标题
})


export default router
